import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

// Zip — smooth, slide-zip collapse to compress long sections without removing content.
export function Zip({ teaser, buttonOpen = "Show full details", buttonClose = "Collapse", defaultOpen = false, testid = "zip", children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={`zip ${open ? "zip-open" : "zip-closed"}`} data-testid={testid}>
      {teaser && <div className="zip-teaser" data-testid={`${testid}-teaser`}>{teaser}</div>}
      <button
        type="button"
        className="zip-toggle"
        onClick={() => setOpen((v) => !v)}
        data-testid={`${testid}-toggle`}
        aria-expanded={open}
      >
        <span>{open ? buttonClose : buttonOpen}</span>
        <ChevronDown size={16} className="zip-chevron" />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="zip-body"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.45, ease: [0.22, 0.9, 0.27, 1] }}
            className="zip-body"
            data-testid={`${testid}-body`}
          >
            <div className="zip-body-inner">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Zip;
